module.exports = __webpack_public_path__ + "img/truck-bolt.60ee8e90.svg";